import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('recording-review-components-lib', {
  library: 'recording-review-components-lib'
});